<template>
  <div>
    <form-section title="Dados do cliente" icon="mdi-account-outline">
      <v-row dense>
        <v-col cols="12" md="6">
          <input-text-vue
            label="Nome"
            :required="false"
            :disabled="loading"
            :readonly="readonly"
            v-model="client.name"
          />
        </v-col>
        <v-col cols="12" md="3">
          <input-text-vue
            label="CPF *"
            :required="true"
            :disabled="loading"
            :readonly="readonly"
            v-model="client.document"
            v-mask="'###.###.###-##'"
          />
        </v-col>
        <v-col cols="12" md="3">
          <input-text-vue
            label="Telefone"
            :required="false"
            :disabled="loading"
            :readonly="readonly"
            v-model="client.phone"
            v-mask="'(##) #####-####'"
          />
        </v-col>
        <v-col cols="12" md="6">
          <input-text-vue
            label="Email"
            :required="false"
            :disabled="loading"
            :readonly="readonly"
            v-model="client.email"
          />
        </v-col>
      </v-row>
    </form-section>

    <div class="client-form-actions">
      <template v-if="!client.id && !loading">
        <v-btn text class="mr-2" @click="handleCancel">Cancelar</v-btn>
        <v-btn dark color="primary" depressed @click="handleSave">Salvar</v-btn>
      </template>
      <v-btn v-else text @click="handleCancel">Voltar</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import InputTextVue from "@/components/inputs/InputText.vue";
import FormSection from "@/components/ui/FormSection.vue";

import { CreateClient } from "@/services/clients/CreateClient";
import { GetClient } from "@/services/clients/GetClient";
import { format } from "date-fns";
import { ClientDetailsType } from "@/types/client/Client";

export default defineComponent({
  components: { FormSection, InputTextVue },
  data() {
    return {
      loading: false,
      title: "Novo cliente",
      readonly: false,
      client: {
        id: "",
        name: "",
        phone: "",
        email: "",
        document: "",
        createdAt: "",
      } as ClientDetailsType,
    };
  },
  methods: {
    async handleLoadClient() {
      this.readonly = true;
      this.title = "Detalhes do cliente";
      this.loading = true;
      const getClient = new GetClient();
      const client = await getClient.execute(this.$route.params.id);
      this.client.id = client.id || "";
      this.client.name = client.name || "";
      this.client.createdAt = client.createdAt || "";
      this.client.phone = this.formatPhone(client.phone) || "";
      this.client.email = client.email || "";
      this.client.document = this.formatDocument(client.document) || "";

      this.loading = false;
    },
    async handleSave() {
      this.loading = true;
      const createClient = new CreateClient();
      await createClient
        .execute(this.client)
        .then(() => {
          this.$store.dispatch("showSnack", {
            message: "Cliente cadastrado com sucesso",
            color: "green darken-1",
          });
          this.$router.push("/clients");
        })
        .catch(() => {
          this.$store.dispatch("showSnack", {
            message: "Erro ao cadastrar o cliente",
            color: "red",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCancel() {
      this.$router.push("/clients");
    },

    formatPhone: (value: string): string => {
      if (!value) return "";
      const phone = "(" + value.substr(0, 2) + ") " + value.substr(2, 5) + "-" + value.substr(7, 8);
      return phone;
    },
    formatDate: (date: string): string => {
      const dateFormated = format(new Date(date), "dd/MM/yyyy HH:mm:ss");
      return dateFormated;
    },
    formatZipCod: (cep: string): string => {
      return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
    },
    formatDocument: (document: string): string => {
      return document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.handleLoadClient();
    }
  },
});
</script>
<style scoped lang="scss">
.client-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}
</style>
